var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3242_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.60313C12.2287 1.60313 13.0219 2.39625 13.0219 3.375C13.0219 4.35375 12.2287 5.14688 11.25 5.14688C10.2713 5.14688 9.47812 4.35375 9.47812 3.375C9.47812 2.39625 10.2713 1.60313 11.25 1.60313ZM11.25 9.19687C13.7559 9.19687 16.3969 10.4288 16.3969 10.9688V11.8969H6.10313V10.9688C6.10313 10.4288 8.74406 9.19687 11.25 9.19687ZM11.25 0C9.38531 0 7.875 1.51031 7.875 3.375C7.875 5.23969 9.38531 6.75 11.25 6.75C13.1147 6.75 14.625 5.23969 14.625 3.375C14.625 1.51031 13.1147 0 11.25 0ZM11.25 7.59375C8.99719 7.59375 4.5 8.72437 4.5 10.9688V12.6562C4.5 13.1203 4.87969 13.5 5.34375 13.5H17.1562C17.6203 13.5 18 13.1203 18 12.6562V10.9688C18 8.72437 13.5028 7.59375 11.25 7.59375Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9375 3L7.5 6.9375L12 6.75V4.125L7.9375 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 10.3125H7.1875L3.75 12.75L6.75 14.25L14.625 13.875L15.75 13.125L10.875 10.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.85313C10.7287 3.85313 11.5219 4.64625 11.5219 5.625C11.5219 6.60375 10.7287 7.39688 9.75 7.39688C8.77125 7.39688 7.97812 6.60375 7.97812 5.625C7.97812 4.64625 8.77125 3.85313 9.75 3.85313ZM9.75 11.4469C12.2559 11.4469 14.8969 12.6788 14.8969 13.2188V14.1469H4.60313V13.2188C4.60313 12.6788 7.24406 11.4469 9.75 11.4469ZM9.75 2.25C7.88531 2.25 6.375 3.76031 6.375 5.625C6.375 7.48969 7.88531 9 9.75 9C11.6147 9 13.125 7.48969 13.125 5.625C13.125 3.76031 11.6147 2.25 9.75 2.25ZM9.75 9.84375C7.49719 9.84375 3 10.9744 3 13.2188V14.9062C3 15.3703 3.37969 15.75 3.84375 15.75H15.6562C16.1203 15.75 16.5 15.3703 16.5 14.9062V13.2188C16.5 10.9744 12.0028 9.84375 9.75 9.84375Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 5.8125L4.125 11.25L7.125 10.125L9.75 9L8.25 6.75L6.4375 5.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.5625H5.6875L2.25 15L5.25 16.5L10.875 16.125L12.375 15.75L9.375 12.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.10313C7.72875 6.10313 8.52188 6.89625 8.52188 7.875C8.52188 8.85375 7.72875 9.64688 6.75 9.64688C5.77125 9.64688 4.97812 8.85375 4.97812 7.875C4.97812 6.89625 5.77125 6.10313 6.75 6.10313ZM6.75 13.6969C9.25594 13.6969 11.8969 14.9288 11.8969 15.4688V16.3969H1.60313V15.4688C1.60313 14.9288 4.24406 13.6969 6.75 13.6969ZM6.75 4.5C4.88531 4.5 3.375 6.01031 3.375 7.875C3.375 9.73969 4.88531 11.25 6.75 11.25C8.61469 11.25 10.125 9.73969 10.125 7.875C10.125 6.01031 8.61469 4.5 6.75 4.5ZM6.75 12.0938C4.49719 12.0938 0 13.2244 0 15.4688V17.1562C0 17.6203 0.379687 18 0.84375 18H12.6562C13.1203 18 13.5 17.6203 13.5 17.1562V15.4688C13.5 13.2244 9.00281 12.0938 6.75 12.0938Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3242_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUsers);
export default __webpack_public_path__ + "static/media/list-users.7c29d9b276ccfbab18289e128e79009d.svg";
export { ForwardRef as ReactComponent };